<template>
  <f7-page
    name="reportsPage"
    class="main-reportspage"
  >
    <template #fixed>
      <TheNavbar
        :nav-title="$t('common.reports')"
        back-btn-enable
      />
    </template>

    <UCPreload :show="showPreload" />
    <UCAcordeon
      :items="reportList"
      class="sorted-accordion-list"
      :show-badge="false"
      primary="var(--his-slate-blue)"
      font-color="#fff"
      :show-item-border-bottom="true"
      border-item-bottom-color="#E5EEF7"
      group-items
      group-key="groupName"
      chevron-side="left"
      :opened-index="0"
      :closed="true"
    >
      <template #titleOption="{ option }">
        {{ option.items[0].groupName }}
      </template>

      <template #subOption="{ item }">
        <f7-list-item
          media-item
          outline
          class="padding-right"
          :title="item.name"
          link="#"
          @click="goToReport(item.report)"
        />
      </template>
    </UCAcordeon>
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import ReportService from '@/js/services/contracts/ReportService';
import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'ReportsPage',
  components: {
    TheNavbar,
    UCAcordeon,
    UCPreload,
  },

  data() {
    return {
      groupReport: [],
      reportList: [],
      showPreload: false,
    };
  },

  mounted() {
    this.getGroupReport();
  },
  methods: {
    async getGroupReport() {
      this.showPreload = true;
      try {
        this.groupReport = await ReportService.getReportsGroup('Contratos');
        this.reportList = this.parseReportData(this.groupReport);
      } catch {
        HiNotification.Alert('No es posible obtener los informes disponibles. Esta acción requiere de conexión con el servidor');
        f7.views.main.router.back(); // TODO . Revisar no funciona
      }
      this.showPreload = false;
    },
    // required for the component sorted accordion to sort by report groups
    parseReportData(pLstGroupReport) {
      const parsedData = [];
      pLstGroupReport.forEach((groupReport) => {
        if (groupReport.ImpresosAplicacion.length > 0) {
          groupReport.ImpresosAplicacion.forEach((report) => {
            parsedData.push({
              name: report.Nombre,
              groupName: groupReport.Nombre,
              groupCode: groupReport.Codigo,
              report,
            });
          });
        }
      });
      return parsedData;
    },
    goToReport(report) {
      f7.views.main.router.navigate('/report-complete-params/', {
        props: {
          report,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.main-reportspage {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  .accordion-item-content {
    .item-link {
      background-color: transparent;

      .item-title-row {
        &::before {
          color: var(--his-silver) !important;
        }
      }
    }

    .item-title {
      color: #555;
      font-size: 14px;
    }

    .content-item-row:not(:last-child) {
      border-bottom: 1px solid var(--his-silver);
    }
  }
}
</style>
